export const IF_PAGA_FACILE_EDIT_PLACEHOLDERS: string[] = [
  'data_invio', 'data_scadenza', 'importo', 'riferimento', 'nome'
];
